import { defineComponent as _defineComponent } from 'vue'
import {PropType} from "vue";
  import Order from "@/model/Order";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'WorklogDetailsDialogOrderField',
  props: {
    availableOrders: {
      type: Array as PropType<Array<Order>>,
      default: () => new Array<Order>()
    },
    disabled: Boolean,
    errorMessages: {
      type: Array,
      default: () => []
    },
    value: {
      type: Object as PropType<Order>,
      default: () => new Order()
    }
  },
  setup(__props) {

const props = __props

  

return { __sfc: true,props }
}

})